import React from 'react'
import { Table, IconEditLine, IconTrashLine, IconButton } from '@instructure/ui'

const ListTools = ({ tools, onEdit, onDelete }) => (
  <Table caption='list of tools'>
    <Table.Head>
      <Table.Row>
        <Table.ColHeader key='name' id='name'>Name</Table.ColHeader>
        <Table.ColHeader key='registration' id='registration'>Registration</Table.ColHeader>
        <Table.ColHeader key='client-id' id='client-id'>LTI Client ID</Table.ColHeader>
        <Table.ColHeader key='proxy' id='proxy'>Proxy (API Client ID)</Table.ColHeader>
        <Table.ColHeader key='actions' id='actions' textAlign='end'>Actions</Table.ColHeader>
      </Table.Row>
    </Table.Head>
    <Table.Body>
      {tools.map((tool) => (
        <Table.Row key={tool.id}>
          <Table.Cell>{tool.lti?.clientName}</Table.Cell>
          <Table.Cell>{tool.lti?.registrationId}</Table.Cell>
          <Table.Cell>{tool.lti?.clientId}</Table.Cell>
          <Table.Cell>{tool.proxy?.clientId ? tool.proxy.clientId : 'N/A'}</Table.Cell>
          <Table.Cell textAlign='end'>
           <IconButton screenReaderLabel='Edit' renderIcon={<IconEditLine/>} withBackground={false} withBorder={false} margin='xx-small' onClick={() => onEdit(tool)}/>
            <IconButton screenReaderLabel='Delete' renderIcon={<IconTrashLine/>} withBackground={false} withBorder={false} margin='xx-small' onClick={() => onDelete(tool)}/>
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
)
export default ListTools
